module.exports = __webpack_public_path__ + "Flag-104.7640333ec5be51c7423bcf2b301c87df.svg";